import React from "react";
import { Fragment } from 'react';
import { Alert, Button } from "react-bootstrap";

/**
 * ExpoNavAlert
 * - pathName (opcional): caminho atual; se não passado usa window.location.pathname
 * - supportedYears: lista de anos que você quer oferecer como opções (ordem preferencial)
 */
const ExpoNavAlert = ({ pathName }) => {
  const supportedYears = [2025, 2024, 2023];

  const path = (pathName || window.location.pathname || "").toLowerCase();
  const match = path.match(/expomacuco\/(anteriores|\d{4})/i);
  const matched = match ? match[1] : null;

  // currentViewed pode ser número (2025...) ou string 'anteriores' ou null
  const currentViewed = matched === "anteriores" ? "anteriores" : (matched ? parseInt(matched, 10) : null);

  // lista de anos a exibir (removendo o ano atual, salvo se estamos em 'anteriores' que mostra todos)
  const yearsToShow = currentViewed === "anteriores"
    ? supportedYears
    : supportedYears.filter(y => y !== currentViewed);

  // label que aparece no texto principal
  const displayLabel = (currentViewed && currentViewed !== "anteriores")
    ? currentViewed
    : "anos anteriores a 2023";

  // base url (se quiser alterar depois)
  const baseUrl = "https://prefeituramacuco.rj.gov.br/transparencia/diario/expomacuco";

  return (
    <Fragment>
      <Alert variant="warning">
        <p>
          Dentro das publicações feitas relacionadas à Exposição Agropecuária de <strong>{displayLabel}</strong> em Macuco,
          não foi encontrado nenhuma que corresponda a esses filtros.
          Caso queira procurar por publicações não relacionados à Exposição, por favor, clique no link abaixo:
        </p>

        <div className="mb-3">
          <a
            href="https://prefeituramacuco.rj.gov.br/transparencia/diario"
            title="Busque por Todas Publicações"
          >
            <Button variant="warning">Todas Publicações</Button>
          </a>
        </div>

        {yearsToShow.map(year => (
          <div className="mb-3" key={year}>
            <p style={{ marginBottom: '0.375rem' }}>
              Caso esteja buscando pelas publicações da Exposição de {year}:
            </p>
            <a
              href={`${baseUrl}/${year}`}
              title={`Publicações Expo ${year}`}
            >
              <Button variant="warning">Publicações Expo {year}</Button>
            </a>
          </div>
        ))}

        <div className="mb-2">
          <p style={{ marginBottom: '0.375rem' }}>Caso esteja buscando pelas publicações das Exposições de anos anteriores:</p>
          <a
            href={`${baseUrl}/anteriores`}
            title="Publicações anos anteriores"
          >
            <Button variant="warning">Publicações anos anteriores</Button>
          </a>
        </div>
      </Alert>
    </Fragment>
  );
};

export default ExpoNavAlert;